
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

interface LoadingOverlayProps {
  show: boolean;
  onComplete?: () => void;
  logoUrl?: string; 
  companyName?: string;
}

export const LoadingOverlay = ({ 
  show, 
  onComplete,
  logoUrl,
  companyName
}: LoadingOverlayProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [logoError, setLogoError] = useState(false);
  
  // Safely handle mounting on client only
  useEffect(() => {
    setIsMounted(true);
    
    if (show && onComplete) {
      const timer = setTimeout(() => {
        onComplete();
      }, 800); // Increased timeout for more reliable component loading
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);
  
  // If not showing or not mounted on client, don't render
  if (!show || !isMounted) return null;
  
  // Default fallback values
  const displayLogoUrl = logoUrl || "/lovable-uploads/a9d4fe12-5eb2-4884-936a-3da184479c3f.png";
  const displayCompanyName = companyName || "Agent Matcher";

  return (
    <div className="fixed inset-0 z-50 bg-[#F0EADA] flex flex-col items-center justify-center">
      <div className="relative">
        {!logoError && (
          <img 
            src={displayLogoUrl} 
            alt={displayCompanyName} 
            className="h-32"
            onLoad={() => setLogoLoaded(true)}
            onError={() => {
              // Fallback if image fails to load
              console.log("Logo failed to load:", displayLogoUrl);
              setLogoError(true);
            }}
            style={{ display: logoLoaded ? 'block' : 'none' }}
          />
        )}
        <div className="text-2xl font-bold mt-2 text-center">
          {displayCompanyName}
        </div>
      </div>
      
      <div className="mt-6 flex flex-col items-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mb-2" />
        <p className="text-sm text-gray-600">Loading application...</p>
      </div>
    </div>
  );
}
